import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { X } from 'lucide-react';
import { tokens } from '../../theme';
import HandlerSerasaSocoreCPF from '../../components/SerasaScoreCPF';
import HandlerSerasaSocorePj from '../../components/SerasaScorePj';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router';

const isCPF = (value) => value && value.length === 11;
const isCNPJ = (value) => value && value.length > 11;

const ModalConsultResult = ({ open, onClose, dataAPI }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const document = dataAPI?.consult?.document ?? '';
  const isConfirmed = dataAPI?.consult?.stage === 'CONFIRMED';

  const handleClose = () => {
    navigate('/app/redutoconsultas', {
      state: { showAfterConsult: true },
    });
    onClose?.();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          backgroundColor: theme.palette.mode === 'dark' ? '#141414' : '#fff',
          backgroundImage: 'none',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: '8px',
          pt: '20px',
          px: '24px',
          borderBottom: `1px solid ${colors.grey[700]}`,
        }}
      >
        <Typography variant="h5" fontWeight={700} sx={{ color: colors.grey[100] }}>
          {t('titles.redscore')}
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <X size={18} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: '24px', py: '24px' }}>
        {!isConfirmed ? (
          <Box sx={{ py: '40px', textAlign: 'center' }}>
            <Typography variant="body1" sx={{ color: colors.grey[400] }}>
              {t('consultation.noResult')}
            </Typography>
          </Box>
        ) : (
          <>
            {isCPF(document) && <HandlerSerasaSocoreCPF dataAPI={dataAPI} />}
            {isCNPJ(document) && <HandlerSerasaSocorePj dataAPI={dataAPI} />}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalConsultResult;
